import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ModalBody from 'react-bootstrap/ModalBody';
import Blockquote from '../../../components/Blockquote';
import Button from '../../../components/Button';
import CalloutCard from '../../../components/CalloutCard';
import Checkbox from '../../../components/Checkbox/Checkbox';
import CheckboxGroup from '../../../components/Checkbox/CheckboxGroup';
import DefaultCard from '../../../components/DefaultCard';
import IconButton from '../../../components/IconButton/IconButton';
import Link from '../../../components/Link';
import ModalHeader from '../../../components/ModalHeader';
import PricingCalculatorCard, {
  PricingCardListItem,
} from '../../../components/PricingCalculatorCard';
import Radio, { RadioGroup } from '../../../components/Radio';
import SelectableCard from '../../../components/SelectableCard';
import { EnrollmentStore } from '../../../providers/enrollment';
import { getAllHealthSavings } from '../../../services/enrollment';
import {
  DateFormats,
  formatDate,
  openExternalLink,
} from '../../../utils/utils';

export type customHealthSavingsModalProps = {
  showHealthSavingsModal: boolean;
  handleCloseHealthSavingsModal: () => void;
};

const buttonForCalloutCard = [
  <Button
    variant="secondary-outline"
    rightIcon={light('calculator')}
    className="callout-button text-nowrap"
    size="sm"
    onClick={() =>
      openExternalLink(
        'https://qabtr.lifeatworkportal.com/dst/bw_hsalimitOE/?Disclaimer=0'
      )
    }
  >
    HSA Contribution Calculator
  </Button>,
];

const HealthSavingsModal = ({
  showHealthSavingsModal,
  handleCloseHealthSavingsModal,
}: customHealthSavingsModalProps) => {
  const [healthSavingData, setHealthSavingsData] = React.useState<any>({});
  const { activeHealthBenefits, updateCost, updatePlanName } =
    useContext(EnrollmentStore);
  const [showDetails, setShowDetails] = useState<boolean>(false);

  const dataPlans = useMemo(() => {
    return getAllHealthSavings();
  }, []);

  useEffect(() => {
    if (dataPlans) {
      setHealthSavingsData(dataPlans);
      setListItems1([
        {
          text: `Your contributions in ${(new Date().getFullYear())} (est)`,
          value: dataPlans['plans'][0].selfAnnualContributions,
        },
        {
          text: `Company’s contributions in ${(new Date().getFullYear())} (est)`,
          value: dataPlans['plans'][0].companyAnnualContributions,
        },
      ]);
    }
  }, [dataPlans]);

  const [calculatorValue, setcalculatorValue] = React.useState<string | number>(
    1
  );

  useEffect(() => {
    const currentBenefit = activeHealthBenefits.find(
      (benefit: any) => benefit.type === 'health-savings'
    );
    const index = healthSavingData.plans?.findIndex(
      (plan: any) => plan.id === currentBenefit?.plan?.id
    );
    setcalculatorValue(index?.toString());
  }, [activeHealthBenefits, healthSavingData]);

  const [hsaAccountRadioValue, setHsaAccountRadioValue] = React.useState<
    string | number
  >(0);

  const [hsaAccountTransferRadioValue, setHsaAccountTransferRadioValue] =
    React.useState<string | number>(0);

  const [termsCheckboxValue, setTermsCheckboxValue] = React.useState<string[]>(
    []
  );

  const [hsaTerms, setHsaTerms] = React.useState<string[]>([]);

  const [listItems1, setListItems1] = useState<Array<PricingCardListItem>>([
    {
      text: `Your contributions in ${(new Date().getFullYear())} (est)`,
      value: 0,
    },
    {
      text: `Company’s contributions in ${(new Date().getFullYear())} (est)`,
      value: 1000,
    },
  ]);

  const [listItems2, setListItems2] = useState<Array<PricingCardListItem>>([
    {
      text: `Your contributions in ${(new Date().getFullYear())} (est)`,
      value: 0,
    },
    {
      text: `Company’s contributions in ${(new Date().getFullYear())} (est)`,
      value: 1000,
    },
  ]);

  const listItems3 = [
    {
      text: `Your contributions in ${(new Date().getFullYear())} (est)`,
      value: 525,
    },
    {
      text: `Company’s contributions in ${(new Date().getFullYear())} (est)`,
      value: 1000,
    }
  ];

  const [tellMeMore, setTellMeMore] = useState(false);

  const [showForm, setShowForm] = React.useState<boolean>(false);

  const handleInputValueChange = (
    value: number | undefined,
    listItems: Array<PricingCardListItem>,
    setListItems: Function
  ) => {
    let listItemsNew = listItems;
    if (listItemsNew[0]) {
      listItemsNew[0].value = value;
    } else {
      listItemsNew[0] = {
        text: '',
        value: value,
      };
    }
    setListItems(listItemsNew);
  };

  const handleCalculatorChange = (e: string | number) => {
    setcalculatorValue(e);
  };

  const handleChangeListItems = (value: number | undefined, index: number) => {
    if (index) {
      handleInputValueChange(value, listItems2, setListItems2);
    } else {
      handleInputValueChange(value, listItems1, setListItems1);
    }
  };

  const handleContinue = () => {
    if (calculatorValue === '3') {
      updateCost('health-savings', healthSavingData.plans[calculatorValue]);
      updatePlanName('health-savings', healthSavingData.plans[calculatorValue]);
      handleCloseHealthSavingsModal();
    } else if (calculatorValue !== '3' && !showForm) {
      setShowForm(true);
    } else {
      const items = calculatorValue === '0' ? listItems1 : calculatorValue === '1' ? listItems2 : listItems3;
      const newPlanCost = items.find((e) => e.text.includes('Your'));
      const currentPlan = healthSavingData.plans[calculatorValue];

      if (newPlanCost && newPlanCost.value) {
        currentPlan.cost = calculatorValue === '1' ? newPlanCost.value / 12 : newPlanCost.value;
      }

      updateCost('health-savings', currentPlan);
      updatePlanName('health-savings', currentPlan);
      handleCloseHealthSavingsModal();
    }
  };

  const handleHsaValueChange = (e: string | number) => {
    setHsaAccountRadioValue(e);
  };

  const handleHsaAccountTransferValueChange = (e: string | number) => {
    setHsaAccountTransferRadioValue(e);
  };

  const handleOnModalClose = () => {
    handleCloseHealthSavingsModal();
    setcalculatorValue('0');
    setHsaAccountRadioValue(0);
    setShowForm(false);
  };

  const handleOnTermsCheckboxValueChange = (event: any, values: string[]) => {
    setTermsCheckboxValue(values);
  };

  const handleOnHSATermsCheckboxValueChange = (
    event: any,
    values: string[]
  ) => {
    setHsaTerms(values);
  };

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  const handleTellMeMore = () => {
    setTellMeMore((prev) => !prev);
  };

  return (
    <>
      {healthSavingData ? (
        <Modal
          show={showHealthSavingsModal}
          onHide={handleCloseHealthSavingsModal}
          dialogClassName="modal-xl"
          className="custom-health-savings-modal"
        >
          <ModalHeader
            rightButton={
              <div onClick={toggleDetails} className={'icon-button-wrapper'}>
                <IconButton
                  variant="icon-default"
                  icon={light('circle-exclamation')}
                  extLabel="Benefit Info"
                />
              </div>
            }
          >
            <h4 className="text-sm-20-lg-32">
              {healthSavingData['generic']
                ? healthSavingData['generic']['title']
                : ''}
            </h4>
          </ModalHeader>
          <ModalBody>
            <Row className={`expandable-wrapper ${showDetails ? 'open' : ''}`}>
              <div className="d-flex justify-content-center">
                <DefaultCard
                  closeButton={
                    <Link 
                      className='pt-0' 
                      isAlignAtEnd 
                      isWhiteIcon 
                      rightIcon={light('close')}
                      onClick={toggleDetails}
                    />                      
                  }
                  variant="blue-motif"
                  leftHeading={
                    healthSavingData['generic']
                      ? healthSavingData['generic']['info']['title']
                      : ''
                  }
                  leftSubheading={
                    <Container className={'px-0 d-flex flex-column'}>
                      {healthSavingData['generic'] ? (
                        <>
                          <span>
                            {healthSavingData['generic']['info']['description']}
                          </span>
                          {tellMeMore && (
                            <span className={'mt-1'}>
                              {healthSavingData['generic']['info'][
                                'additionalDescription'
                              ] &&
                                `The ${formatDate(
                                  new Date(),
                                  DateFormats.ONLY_YEAR
                                )} IRS maximum contribution is $3,500 for individuals or $7,000 for families. If you are age 55 or older, or turn age 55 anytime in ${formatDate(
                                  new Date(),
                                  DateFormats.ONLY_YEAR
                                )}, you can add an additional $1,000 contribution. If you have already made contributions to another HSA this year, you will need to factor that into your planned contributions below. Your total HSA contributions cannot exceed the annual limits.`}
                            </span>
                          )}
                        </>
                      ) : (
                        ''
                      )}
                    </Container>
                  }
                  button={
                    <Button
                      onClick={handleTellMeMore}
                      variant="primary-shadow"
                      size="sm"
                    >
                      {tellMeMore ? 'Tell me less' : 'Tell me more'}
                    </Button>
                  }
                  className={'mb-12'}
                />
              </div>
            </Row>
            <Container className="p-0">
              <Row className="mb-7 mb-lg-12">
                <Container className="d-flex justify-content-center">
                  <CalloutCard
                    cardIcon={light('screwdriver-wrench')}
                    buttons={buttonForCalloutCard}
                  >
                    <Row>
                      <span className="bolder-text text-ligther-grey">
                        Need help knowing how to contribute?
                      </span>
                      <p>
                        Use the{' '}
                        <span className="bolder-text text-ligther-grey">
                          HSA Contribution Calculator{' '}
                        </span>
                        to check what works best for you
                      </p>
                    </Row>
                  </CalloutCard>
                </Container>
              </Row>
              <RadioGroup
                name={'pricing-test1'}
                value={calculatorValue}
                onChange={handleCalculatorChange}
              >
                {dataPlans && dataPlans['plans'] ? dataPlans['plans'].map( (plan, index) => (
                  <Row className="pb-7">
                    {index !== 3 ? <PricingCalculatorCard
                      title={plan.title}
                      subtitle={
                        <div>
                          <div>{plan.subtitle1}</div>
                          {calculatorValue === index.toString() && plan.subtitle2 || ''}
                        </div>
                      }
                      radioButtonValue={index.toString()}
                      selected={calculatorValue === index.toString()}
                      radioButtonDefaultChecked={calculatorValue === index.toString()}
                      listItems={!index ? listItems1 : index === 1 ? listItems2 : listItems3}
                      isCollapsedView={calculatorValue !== index.toString()}
                      isPerPayPeriod={index !== 1}
                      minInputValue={index ? '100' : '1'}
                      maxInputValue={index ? '7300' : '525'}
                      disableNumberInputField={index === 2}
                      alwaysShowSubtitle={true}
                      handleChange={(value: number | undefined) => handleChangeListItems(value, index)}
                    />
                    : <PricingCalculatorCard
                        title="No Coverage"
                        subtitle={
                          <div>
                            <div>You could receive up to <b>$1,000</b> from your employer if sign up for a Health Savings Account!</div>
                          </div>
                        }
                        isCollapsedView={true}
                        disableNumberInputField={true}
                        listItems={[{text: '', value: 0}]}
                        radioButtonValue="3"
                        handleChange={() => {}}
                        selected={calculatorValue === '3'}
                        alwaysShowSubtitle={true}
                        disabled
                      />}
                  </Row>
                )) : ''}
              </RadioGroup>
              {calculatorValue !== '3' && showForm && (
                <div>
                  <Container className="px-0">
                    <div className="hsa-account-row">
                      <h5 className="hsa-account-title">
                        Do you want to set up your HSA Account now?
                      </h5>
                    </div>
                    <Row className="note-row m-0">
                      <p>
                        Note: You need to set up an HSA account in order to
                        contribute.
                      </p>
                    </Row>
                    <div className="radio-buttons-row m-0">
                      <RadioGroup
                        name={'hsa-account'}
                        value={hsaAccountRadioValue}
                        onChange={handleHsaValueChange}
                      >
                        <div
                          className={`px-lg-7 py-7 m-0 d-flex flex-column ${
                            hsaAccountRadioValue === '1'
                              ? 'selected-hsa-account'
                              : ''
                          }`}
                        >
                          <div className="d-flex justify-content-between">
                            <div>
                              <Radio
                                value={'1'}
                                id={'hs-1'}
                                label={'I already have an HSA Account'}
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className={`px-lg-7 py-7 m-0 d-flex flex-column ${
                            hsaAccountRadioValue === '2'
                              ? 'selected-hsa-account'
                              : ''
                          }`}
                        >
                          <div className="d-flex justify-content-between radio-title">
                            <div className="radio-btn-col">
                              <Radio
                                value={'2'}
                                id={'2'}
                                label={
                                  'Yes, I would like to set it up now (only takes a minute)'
                                }
                              />
                            </div>
                            <div className="radio-btn-col radio-btn-icon ms-7 ms-lg-0">
                              <FontAwesomeIcon icon={light('chevron-down')} />
                            </div>
                          </div>
                          {hsaAccountRadioValue === '2' && (
                            <Row className="hsa-account-setup">
                              <Row className="pb-3">
                                <h6>
                                  After agreeing to the Disclosures &
                                  Agreements below:
                                </h6>
                              </Row>
                              <Row className="pb-10">
                                <p className="pb-5">
                                  1. HealthEquity banking partner, BNY
                                  Mellon, will screen your identity per the
                                  requirments of the U.S. Pariot Act.
                                </p>
                                <p className="pb-1">
                                  {' '}
                                  2. If screening Passes
                                </p>
                                <Container className="hsa-setup-steps-container">
                                  <p className="pb-1 hsa-setup-steps">
                                    Your HSA account will be open and ready to
                                    receive contributions.
                                  </p>
                                  <p className="pb-1 hsa-setup-steps">
                                    An HSA debit card will be mailed to you.
                                  </p>
                                </Container>
                              </Row>
                              <Row className="pb-7">
                                <p className="hsa-setup-note">
                                  Note: You must open all documents before
                                  checking the box.
                                </p>
                              </Row>
                              <Row className="hsa-documents-row flex-column">
                                <Link
                                  className="readed-document py-0"
                                  leftIcon={light('check')}
                                  isBlue
                                >
                                  Electronic Access Management
                                </Link>
                                <Link
                                  className="readed-document py-0"
                                  leftIcon={light('check')}
                                  isBlue
                                >
                                  Deposit Account and Disclosure Agreement
                                </Link>
                                <Link
                                  leftIcon={light('check')}
                                  className="py-0"
                                  isBlue
                                >
                                  Fee and rate Schedule
                                </Link>
                                <Link
                                  leftIcon={light('check')}
                                  className="py-0"
                                  isBlue
                                >
                                  Privacy Notice
                                </Link>
                              </Row>
                              <Row className="pl-13">
                                <CheckboxGroup
                                  name="termsAndConditions"
                                  value={termsCheckboxValue}
                                  onChange={handleOnTermsCheckboxValueChange}
                                >
                                  <Checkbox
                                    id={'11'}
                                    name={'documents'}
                                    value={'termsAndConditions'}
                                    variant="sm"
                                    label={
                                      'By checking this box, you have read and agreed to the above documents'
                                    }
                                  />
                                </CheckboxGroup>
                              </Row>
                              {termsCheckboxValue[0] && (
                                <Row className="m-0 p-0 mt-lg-7">
                                  <Row className="m-0 p-0">
                                    <h6>Health Saving Account Transfer</h6>
                                  </Row>
                                  <Row className="m-0 p-0">
                                    <p>
                                      If applicable, by clicking "YES,
                                      transfer my existing HSA account", you
                                      herby request and authorize your prior
                                      HSA custodian, HSA Bank, to close your
                                      HSA account in January 2020,
                                      transferring 100% of your HSA balance to
                                      HealthEquity.
                                    </p>
                                  </Row>
                                  <RadioGroup
                                    name={'hsa-account-transfer'}
                                    value={hsaAccountTransferRadioValue}
                                    onChange={
                                      handleHsaAccountTransferValueChange
                                    }
                                  >
                                    <Radio
                                      value={'5'}
                                      id={'hs-2'}
                                      label={
                                        'Yes, transfer my existing HSA Account'
                                      }
                                      className="mt-7"
                                    />
                                    <Radio
                                      value={'1'}
                                      id={'hs-3'}
                                      label={
                                        'No, I don’t want to transfer an existing HSA acount'
                                      }
                                      className="mt-7"
                                    />
                                    {hsaAccountTransferRadioValue === '5' && (
                                      <>
                                        <Row className="pt-7">
                                          <span
                                            className={
                                              'px-0 fw-light text-fs-6 d-inline-block'
                                            }
                                          >
                                            You confirm you have read the
                                            following applicable documentation{' '}
                                            <Link
                                              isBold={false}
                                              isBlue
                                              className={
                                                'py-0 d-inline-block fw-light'
                                              }
                                              target={'_blank'}
                                              href={`${
                                                process.env.PUBLIC_URL
                                              }/${'blank-demo-example.pdf'}`}
                                            >
                                              HSA Bank Transfer Policy
                                            </Link>
                                          </span>
                                          <Row className="pt-7">
                                            <Blockquote>
                                              <span>
                                                Note: If you have existing HSA
                                                balances at other custodian(s)
                                                and would like to transfer
                                                those to HealthEquity after
                                                you complete your enrollment,
                                                please visit
                                                <span
                                                  className={
                                                    'text-sub1 fw-light d-inline-block'
                                                  }
                                                >
                                                  <Link
                                                    isBold={false}
                                                    target={'_blank'}
                                                    href={
                                                      'https://app.teamwalnut.com/player/?demoId=e9baf7b9-ac3d-4400-8a96-898d04a45259&showGuide=true&showGuidesToolbar=true&showHotspots=true&source=app'
                                                    }
                                                    isBlue
                                                    className={
                                                      'py-0 ms-1 text-primary d-inline-block'
                                                    }
                                                  >
                                                    HealthEquity HSA
                                                    Transfer.
                                                  </Link>
                                                </span>
                                              </span>
                                            </Blockquote>
                                          </Row>
                                          <CheckboxGroup
                                            name="termsAndConditions"
                                            value={hsaTerms}
                                            onChange={
                                              handleOnHSATermsCheckboxValueChange
                                            }
                                          >
                                            <Checkbox
                                              id={'9'}
                                              name={'checked'}
                                              value={'termsAndConditions'}
                                              variant="sm"
                                              label={
                                                'I agree to all the terms and conditions outlined below'
                                              }
                                              className="mt-7"
                                            />
                                          </CheckboxGroup>
                                        </Row>
                                        {hsaTerms[0] && (
                                          <Row className="pt-7">
                                            <Blockquote>
                                              <span>
                                                Clicking{' '}
                                                <span className="fw-bolder">
                                                  Continue
                                                </span>{' '}
                                                below acts as your legally
                                                binding signature and saves
                                                your election.
                                              </span>
                                            </Blockquote>
                                          </Row>
                                        )}
                                      </>
                                    )}
                                  </RadioGroup>
                                </Row>
                              )}
                            </Row>
                          )}
                        </div>
                        <div
                          className={`px-lg-7 py-7 m-0 d-flex justify-content-between ${
                            hsaAccountRadioValue === '3'
                              ? 'selected-hsa-account'
                              : ''
                          }`}
                        >
                          <Radio
                            value={'3'}
                            id={'3'}
                            label={
                              ' No, I don’t want to set it up now, I’ll set it up later'
                            }
                          />
                        </div>
                      </RadioGroup>
                    </div>
                    {hsaAccountRadioValue === '3' && (
                      <Row className="m-0 pt-7">
                        <Blockquote
                          variant="warning-bg"
                          lineVariant="warning"
                        >
                          <span>
                            <b className={'d-block'}>
                              Are you sure? It only takes a minute!
                            </b>
                            You can not contribute or receive the company
                            contributions until you set up your account.
                          </span>
                        </Blockquote>
                      </Row>
                    )}
                  </Container>
                </div>
              )}
            </Container>
          </ModalBody>
          <Modal.Footer className="pt-7">
            <Button
              onMouseDown={handleOnModalClose}
              className="text-nowrap mt-7 mt-lg-0"
              variant="primary-outline"
            >
              Cancel
            </Button>
            <Button
              onMouseDown={handleContinue}
              className="text-nowrap"
              variant="primary"
            >
              Continue
            </Button>
          </Modal.Footer>
        </Modal>
      ) : (
        'NO DATA'
      )}
    </>
  );
};

export default HealthSavingsModal;
